import React from 'react';
import { connect } from 'react-redux';
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;
// @ components
import DocumentationContact from 'components/documentationInfo/DocumentationContact';
import FeatureSection from 'components/documentationInfo/FeatureSection';
import ButtonUnderstood from 'components/documentationInfo/ButtonUnderstood';
import { getCreditCardImage } from 'utilities/creditCard/creditCard';

const CreditCardSuccess = ({ userProfile: { name }, partner }) => {
    return (
        <div className="documentation-info-view" data-testid="credit_card_success">
            <div className="prospects-gutter prospects-prepend-margin basic-layering fix-margin-top">
                <div className="messages-container documentation-info-view__congrats">
                    <div className="icon-container">
                        <i className="icons icons--icon-success-blue"></i>
                    </div>
                    <div className="text-container">
                        <h2 className="font-heading2">
                            <FormattedText value="documentation-congratulations" injectedStrings={[name]} />
                        </h2>
                        <span className="dash-blue" />
                        <FormattedText value="documentation-congratulationsSuccess" />
                    </div>
                </div>
            </div>
            <div className="documentation-info-view__divider"></div>
            <FeatureSection
                icon={getCreditCardImage(partner?.get('id'))}
                title={formatText('documentation-successTCTitle')}
                itemList={[
                    'documentation-successTCitem1',
                    'documentation-successTCitem2',
                    'documentation-successTCitem3',
                    'documentation-successTCitem4',
                ]}
            />
            <div className="documentation-info-view__divider"></div>
            <div className="prospects-gutter prospects-prepend-margin basic-layering">
                <div className="documentation-info-view__further">
                    <h3 className="font-heading3">
                        <FormattedText value="documentation-further" />
                    </h3>
                    <span className="dash-blue" />
                    <ul>
                        <li>
                            <div className="documentation-info-view__further__subtitle">
                                <FormattedText value="documentation-successFurtherItem1Text" />
                            </div>
                        </li>
                        <li>
                            <span className="documentation-info-view__further__item-title">
                                <FormattedText value="documentation-successFurtherItem2Title" />
                            </span>
                            <div className="documentation-info-view__further__subtitle">
                                <FormattedText value="documentation-successFurtherItem2Text" />
                            </div>
                        </li>
                    </ul>
                </div>
                <hr />
                <DocumentationContact />
            </div>
            <ButtonUnderstood />
        </div>
    );
};

export default connect(state => ({
    userProfile: state.userProfile,
    partner: state.products.get('partner'),
}))(CreditCardSuccess);
